<template>
    <div id="content">
        <LoadingIntro v-if="initialLoading" />

        <div v-else class="grid-wrapper univstudy__app__holder" :class="{ loading: loading }">
            <div class="full-width-grid intro-background">
                <div class="grid-wrapper">
                    <div class="intro__content">
                        <h1 class="step--7 black-primary">
                            {{ printString("search_programs") }}
                        </h1>
                    </div>
                </div>
                <div class="intro-gradient">
                    <div class="intro-gradient__red"></div>
                    <div class="intro-gradient__yellow"></div>
                    <div class="intro-gradient__white"></div>
                    <div class="intro-gradient__white"></div>
                </div>
            </div>

             <div class="loader"></div>

            <div class="full-width-grid">
                <div class="grid-wrapper univstudy__filters__holder">
                    <div class="univstudy__filters">
                        <FilterDropdown
                            :label="printString('program_level')"
                            :options="filters.program_level"
                            v-model="selectedProgramLevels"
                            isCheckbox
                            @apply-filters="applyFilters"
                        />

                        <FilterDropdown
                            :label="printString('language')"
                            :options="filters.language"
                            v-model="selectedLanguage"
                            isCheckbox
                            @apply-filters="applyFilters"
                        />

                        <FilterDropdown
                            :label="printString('area_of_study')"
                            :options="filters.area_of_study"
                            v-model="selectedAreasOfStudy"
                            hasSearch
                            isCheckbox
                            @apply-filters="applyFilters"
                        />

                        <div class="univstudy__search__holder">
                            <label for="list-search">
                                <span class="vh"> search</span>
                                <input
                                    id="list-search"
                                    v-model="searchQuery"
                                    type="search"
                                    :placeholder="printString('search_placeholder')"
                                    @keyup.enter="applyFilters"
                                    @search="handleSearchClear"
                                />
                                <button @click="applyFilters">
                                    <span class="vh"> search </span>
                                    <span class="ico-search" v-html="ico_search" />
                                </button>
                            </label>
                        </div>

                        <!-- Add this button for mobile -->
                        <button
                            class="other-filters-button general-button"
                            @click="toggleMobileFilters"
                            v-show="isMobile"
                            id="other-filters-button"
                        >
                            <span v-html="ico_others" />
                            {{ printString("other_filters") }}
                        </button>

                        <button
                            v-if="isFilterApplied"
                            class="general-button reset-filters"
                            @click="resetFilters"
                        >
                            <span v-html="ico_reset_16" />
                            {{ printString("reset_all") }}
                        </button>
                    </div>
                </div>
            </div>

            <div class="univstudy__content">
                <!-- Modify the sidebar filters div -->
                <div class="univstudy__sidebar__holder">
                    <div
                        class="univstudy__sidebar__filters"
                        :class="{ 'mobile-filters': isMobile, show: showMobileFilters }"
                        :tabindex="isMobile && !showMobileFilters ? -1 : undefined"
                        id="sidebar-filters"
                    >

                        <div class="univstudy__sidebar__filters__close">
                            <h2 class="step--4">
                                {{ printString("more_filters") }}
                            </h2>
                            <button
                                class="close-filters-button general-button only-icon"
                                @click="toggleMobileFilters"
                                v-show="isMobile"
                                id="close-sidebar-filters"
                            >
                                <span v-html="ico_close_16" />
                                <span class="vh">{{ printString("close") }}</span>
                            </button>
                        </div>

                        <h2 class="step--4 bottom-underlined margin--s-m">
                            {{ printString("more_filters") }}
                        </h2>

                        <div v-if="ads && ads.length > 0" class="PartnersAd__holder most_popular_ad square-ads programs-sidebar-ads">
                            <div class="wrapper">
                                <div class="PartnersAd PartnersAd1 PartnersAd--list-ad">
                                    <ul>
                                        <li v-for="(ad, adIndex) in ads" :key="adIndex">
                                            <div class="PartnersAd__card PartnersAd__card--image ad-tracking" :data-sp-brand="ad.brand" :data-sp-content="ad.label" data-sp-location="programs_list_sidebar">
                                                <a :href="ad.link" target="_blank" class="ad-tracking-link" :data-sp-content="ad.label" data-sp-location="programs_list_sidebar" :data-sp-brand="ad.brand">
                                                    <div class="PartnersAd__card__desktop">
                                                        <img :src="ad.image.url" :alt="ad.label" />
                                                        <p class="paragraph--caption">
                                                            {{ printString('advertisement') }}
                                                        </p>
                                                    </div>
                                                </a>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>

                        <FilterSidebar
                            v-if="filters.province_territory.length > 0"
                            :title="printString('province_territory')"
                            :options="filters.province_territory"
                            v-model="selectedProvinces"
                            inputType="radio"
                            radioName="province"
                            @applyFilters="applyFilters"
                        />

                        <div
                            class="univstudy__sidebar__filter toggle-container margin--s-m"
                            v-if="filters.coopavailability !== null"
                        >
                            <label for="coop">
                                <h3 class="step--1">
                                    {{ printString("co_op_availability") }}
                                </h3>
                                <div class="toggle-container__toggle__holder">
                                    <span>{{ coopAvailability ? printString('yes') : printString('no') }}</span>
                                    <div class="toggle-container__toggle">
                                        <input
                                            id="coop"
                                            type="checkbox"
                                            v-model="coopAvailability"
                                            @change="applyFilters"
                                        />
                                        <span class="slider"></span>
                                    </div>
                                </div>
                            </label>
                        </div>

                        <div
                            class="univstudy__sidebar__filter toggle-container margin--s-m"
                            v-if="filters.remotelearning !== null"
                        >
                            <label for="remote_learning">
                                <h3 class="step--1">
                                    {{ printString("remote_learning") }}
                                </h3>
                                <div class="toggle-container__toggle__holder">
                                    <span>{{ remoteLearning ? printString('yes') : printString('no') }}</span>
                                    <div class="toggle-container__toggle">
                                        <input
                                            id="remote_learning"
                                            type="checkbox"
                                            v-model="remoteLearning"
                                            @change="applyFilters"
                                        />
                                        <span class="slider"></span>
                                    </div>
                                </div>
                            </label>
                        </div>

                        <FilterSidebar
                            v-if="filters.universities.length > 0"
                            :title="printString('university')"
                            :options="filters.universities"
                            v-model="selectedUniversities"
                            inputType="radio"
                            radioName="university"
                            @applyFilters="applyFilters"
                        />
                    </div>
                </div>

                <div class="univstudy__block__holder" v-if="filteredPrograms.length > 0">
                    <h2 class="margin--s-m step--4">
                        {{ printString("search_results_for_programs") }}
                    </h2>
                    <p class="margin--l-xl" v-if="pagination.total_results">
                        {{ printString("showing") }} {{ pagination.total_results }}
                        {{ printString("programs") }}
                    </p>
                    <ul class="margin--xl-2xl programs-list">
                        <template v-for="(program, index) in filteredPrograms" :key="program.id">
                            <ProgramBlock
                                :program="program"
                                :saved-list="savedList"
                                :compare-list="compareListPrograms"
                                :max-compare-items="maxCompareItems"
                                :max-saved-items="maxSavedItems"
                                :is-dashboard="isDashboard"
                                @add-to-compare="handleAddToCompare"
                                @save-to-list="handleSaveToList"
                            />
                        </template>
                    </ul>

                    <button
                        class="general-button border-grey"
                        v-if="pagination.page < pagination.total_pages"
                        @click="loadMore"
                    >
                        {{ printString("load_more") }}
                    </button>
                </div>

                <div v-else>
                    <p class="margin--l-xl">
                        {{ printString("no_results_found") }}
                    </p>
                </div>

                <ComparePopup
                    :compare-list="comparePrograms"
                    :item-type="'program'"
                    :is-visible="isComparePopupVisible"
                    :is-loading="loading"
                    @remove-from-compare="removeFromCompare"
                    @hide-popup="hideComparePopup"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { ref, computed, watch } from "vue";
import FilterDropdown from "./FilterDropdown.vue";
import FilterSidebar from "./FilterSidebar.vue";
import ProgramBlock from "./ProgramBlock.vue";
import LoadingIntro from "./LoadingIntro.vue";
import ComparePopup from "./ComparePopup.vue";
import { useRoute, useRouter } from 'vue-router';

export default {
    name: "Programs",
    components: { FilterDropdown, FilterSidebar, ProgramBlock, LoadingIntro, ComparePopup },
    data() {
        return {
            programs: [],
            rest_api: window.rest_api,
            filteredPrograms: [],
            previousPrograms: [], // New array to hold previously loaded programs
            filters: {},
            pagination: {},
            selectedProvinces: [],
            selectedAreasOfStudy: [],
            selectedProgramLevels: [],
            selectedUniversities: [],
            selectedLanguage: "",
            searchQuery: "",
            coopAvailability: null, // Set default as null, indicating no filter applied yet
            remoteLearning: null, // Set default as null
            compareListPrograms: [], // This will now be populated from local storage
            savedList: [], // This will store the saved programs
            pageNumber: 1, // Keep track of the current page
            loading: false, // Add this line
            site_lang: window.lang,
            is_logged_in: window.is_logged_in,
            ico_search_16: window.ico_search_16,
            ico_search: window.ico_search,
            ico_reset_16: window.ico_reset_16,
            ico_dropdown_arrow: window.ico_dropdown_arrow,
            ico_close_16: window.ico_close_16,
            ico_others: window.ico_others,
            isDashboard: false,
            maxCompareItems: 3, // Maximum number of programs that can be compared
            comparePrograms: [], // This will store the fetched compare programs
            isComparePopupVisible: false, // Add this line
            maxSavedItems: 10, // Maximum number of programs that can be saved
            initialLoading: true, // Add this line
            isMobile: false,
            showMobileFilters: false,
            ads: JSON.parse(window.programs_ad || '[]'),
        };
    },
    watch: {
        comparePrograms: {
            handler(newList) {
                if (newList.length > 0) {
                    this.isComparePopupVisible = true;
                } else {
                    this.isComparePopupVisible = false;
                }
            },
            immediate: true,
        },
        selectedProvinces() {
            this.saveFilterState();
        },
        selectedAreasOfStudy() {
            this.saveFilterState();
        },
        selectedProgramLevels() {
            this.saveFilterState();
        },
        selectedUniversities() {
            this.saveFilterState();
        },
        selectedLanguage() {
            this.saveFilterState();
        },
        searchQuery() {
            this.saveFilterState();
        },
        coopAvailability() {
            this.saveFilterState();
        },
        remoteLearning() {
            this.saveFilterState();
        },
        ads: {
            immediate: true,
            handler(newAds) {
                console.log('Ads data changed:', {
                    adsLength: newAds?.length || 0,
                    adsData: newAds
                });
            }
        },
        '$route.query': {
            handler(newQuery) {
                const urlParams = this.getParamsFromUrl();
                
                // Only update filters if they're different from current values
                if (!this.areFiltersEqual(urlParams)) {
                    this.selectedProvinces = urlParams.provinces;
                    this.selectedAreasOfStudy = urlParams.areasOfStudy;
                    this.selectedProgramLevels = urlParams.programLevels;
                    this.selectedUniversities = urlParams.universities;
                    this.selectedLanguage = urlParams.language;
                    this.searchQuery = urlParams.search;
                    this.coopAvailability = urlParams.coop;
                    this.remoteLearning = urlParams.remote;
                    
                    this.applyFilters();
                }
            },
            immediate: true
        }
    },
    computed: {
        // Computed property to check if any filters are applied
        isFilterApplied() {
            return (
                this.selectedProvinces.length > 0 ||
                this.selectedAreasOfStudy.length > 0 ||
                this.selectedProgramLevels.length > 0 ||
                this.selectedUniversities.length > 0 ||
                this.selectedLanguage !== "" ||
                this.searchQuery !== "" ||
                this.coopAvailability !== null || // Only consider the filter if it's not null
                this.remoteLearning !== null // Only consider the filter if it's not null
            );
        },
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        return { route, router };
    },
    mounted() {
        console.log("Programs component mounted");
        const urlParams = this.getParamsFromUrl();
        
        // Set initial filter values from URL
        this.selectedProvinces = urlParams.provinces;
        this.selectedAreasOfStudy = urlParams.areasOfStudy;
        this.selectedProgramLevels = urlParams.programLevels;
        this.selectedUniversities = urlParams.universities;
        this.selectedLanguage = urlParams.language;
        this.searchQuery = urlParams.search;
        this.coopAvailability = urlParams.coop;
        this.remoteLearning = urlParams.remote;

        const hadSavedState = this.loadFilterState();
        
        if (hadSavedState) {
            // We have saved state with results, no need to fetch
            this.fetchPrograms();
        }

        if (this.is_logged_in) {
            this.fetchSavedPrograms();
        }

        this.updateLanguageSwitcherUrl();

        this.loadCompareListFromStorage(); // Load compare list from local storage
        this.checkMobile();

        window.addEventListener("resize", this.checkMobile);
        document.addEventListener("keydown", this.handleEscKey);

        this.$nextTick(() => {
            if (this.isMobile && !this.showMobileFilters) {
                this.setFilterElementsTabIndex(-1);
            }
        });
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.checkMobile);
        document.removeEventListener("keydown", this.handleEscKey);
    },
    methods: {
        async fetchPrograms() {
            this.loading = true;
            try {
                const requestData = {
                    apikey: window.api_key,
                    programlevel: this.selectedProgramLevels,
                    language: this.selectedLanguage || "",
                    areaofstudy: this.selectedAreasOfStudy,
                    keyword: this.searchQuery,
                    province: this.selectedProvinces,
                    coopavailability: this.coopAvailability || null,
                    remotelearning: this.remoteLearning || null,
                    universities: this.selectedUniversities,
                    p_number: this.pageNumber,
                    site_lang: this.site_lang,
                };

                const cacheKey = await this.getCacheKey(requestData);
                
                const cachedData = await this.getCachedData(cacheKey);
                if (cachedData) {
                    console.log('Using cached data');
                    this.handleProgramsData(cachedData);
                    return;
                }

                const response = await fetch(
                    `${window.api_base_url}/api/programs/`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(requestData),
                    }
                );

                if (!response.ok) {
                    const errorBody = await response.text();
                    console.error(`Error: ${response.status} - ${response.statusText}`);
                    console.error(`Response body: ${errorBody}`);
                    throw new Error(`Error: ${response.statusText}`);
                }

                const data = await response.json();
                
                // Only cache if there are search results
                if (data.search_results && data.search_results.length > 0) {
                    await this.setCachedData(cacheKey, data);
                }
                
                this.handleProgramsData(data);

            } catch (error) {
                console.error("Error fetching programs:", error);
            } finally {
                this.loading = false;
                this.$nextTick(() => {
                    if (this.initialLoading) {
                        this.selectRandomAd();
                        this.initialLoading = false;
                    }
                });
            }
        },
        handleProgramsData(data) {
            this.programs = data.search_results;
            this.filters = data.filters;
            this.pagination = data.pagination;

            if (this.pageNumber === 1) {
                this.filteredPrograms = data.search_results;
                this.previousPrograms = data.search_results;
            } else {
                this.filteredPrograms = [...this.previousPrograms, ...data.search_results];
                this.previousPrograms = this.filteredPrograms;
            }

            // Wait for DOM update then handle ads
            this.$nextTick(() => {
                // Only run selectRandomAd if we have programs and ads
                if (this.filteredPrograms.length > 0 && this.ads && this.ads.length > 0) {
                    setTimeout(() => {
                        this.selectRandomAd();
                    }, 100); // Small delay to ensure DOM is fully rendered
                }
            });
        },
        applyFilters() {
            this.pageNumber = 1;
            this.saveFilterState();
            this.updateUrlParams();
            this.fetchPrograms();
            window.scrollTo({ top: 0, behavior: "smooth" });
        },
        loadMore() {
            if (this.pagination.page < this.pagination.total_pages) {
                this.pageNumber++;
                this.fetchPrograms(); // Fetch next set of programs
            }
        },
        resetFilters() {
            // Reset all the selected filters
            this.selectedProvinces = [];
            this.selectedAreasOfStudy = [];
            this.selectedProgramLevels = [];
            this.selectedUniversities = [];
            this.selectedLanguage = "";
            this.searchQuery = "";
            this.coopAvailability = null; // Reset Co-op availability
            this.remoteLearning = null; // Reset Remote Learning

            // Clear URL parameters
            window.history.pushState({}, '', window.location.pathname);
            
            this.applyFilters(); // Fetch programs after resetting filters
        },
        async fetchComparePrograms() {
            if (this.compareListPrograms.length < 1) {
                console.log("No programs to compare.");
                this.compareSchools = [];
                this.isComparePopupVisible = false;
                return;
            }

            this.loading = true;

            try {
                const relevantIds = this.compareListPrograms
                .map((id) => {
                    return id;
                })
                .filter((id) => id !== "");

                console.log("Relevant IDs:", relevantIds);

                const requestData = {
                    apikey: window.api_key,
                    program_ids: relevantIds,
                    site_lang: this.site_lang,
                };

                console.log("Sending request with data:", requestData);

                const response = await fetch(
                    `${window.api_base_url}/api/programs-by-id/`,
                    {
                        method: "POST",
                        headers: {
                        "Content-Type": "application/json",
                        },
                        body: JSON.stringify(requestData),
                    }
                );

                if (!response.ok) {
                    const errorBody = await response.text();
                    console.error(`Error: ${response.status} - ${response.statusText}`);
                    console.error(`Response body: ${errorBody}`);
                    throw new Error(`Error: ${response.statusText}`);
                }

                const data = await response.json();
                console.log("Fetched Compare Programs:", data);

                // Update this line to handle the new response structure
                this.comparePrograms = data.results || [];
                console.log("Compare Programs:", this.comparePrograms);

                // Set isComparePopupVisible to true if there are programs to compare
                this.isComparePopupVisible = this.comparePrograms.length > 0;
            } catch (error) {
                console.error("Error fetching compare programs:", error);
            } finally {
                this.loading = false;
            }
        },
        removeFromCompare({ id, altLangId }) {
            console.log("removeFromCompare", id, altLangId);
            const index = this.compareListPrograms.findIndex((id) => id === id);
            if (index !== -1) {
                this.compareListPrograms.splice(index, 1);
                this.saveCompareListToStorage();
                this.fetchComparePrograms();
            }
        },
        hideComparePopup() {
            this.isComparePopupVisible = false;
        },
        handleAddToCompare(programId) {
            const index = this.compareListPrograms.indexOf(programId);

            // If program is already in the compare list, remove it
            if (index !== -1) {
                this.compareListPrograms.splice(index, 1);
                console.log(`Program removed from compare list: ${programId}`);
            } else if (this.compareListPrograms.length < this.maxCompareItems) {
                // Otherwise, add the program id to the compare list as an array element
                this.compareListPrograms.push(programId);
                console.log(`Program added to compare list: ${programId}`);
                this.isComparePopupVisible = true;
            } else {
                console.warn(
                `Compare list is full. Max ${this.maxCompareItems} programs allowed.`
                );
            }

            this.saveCompareListToStorage();
            this.fetchComparePrograms();
        },
        loadCompareListFromStorage() {
            const storedList = localStorage.getItem("compareListPrograms");
            if (storedList) {
                this.compareListPrograms = JSON.parse(storedList);
                this.fetchComparePrograms(); // This will now set isComparePopupVisible
            }
        },
        saveCompareListToStorage() {
            localStorage.setItem(
                "compareListPrograms",
                JSON.stringify(this.compareListPrograms)
            );
            console.log("Compare list saved to local storage:", this.compareListPrograms);
        },
        async handleSaveToList(programId) {
            console.log("handleSaveToList", programId);

            const index = this.savedList.indexOf(programId);

            // If program is already in the saved list, remove it
            if (index !== -1) {
                this.savedList.splice(index, 1);
                console.log(`Program removed from saved list: ${programId}`);
            } else {
                // Otherwise, add the program id to the saved list
                this.savedList.push(programId);
                console.log(`Program saved: ${programId}`);
            }

            console.log("Updated Saved list:", this.savedList);

            // Send the updated savedList to the backend
            this.loading = true;
            try {
                const response = await fetch(`${this.rest_api}/wp-json/custom/v1/save-programs`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "X-WP-Nonce": window.nonce,
                    },
                    credentials: "same-origin",
                    body: JSON.stringify({ savedList: this.savedList }),
                });

                if (!response.ok) {
                    const errorBody = await response.text();
                    console.error(
                        `Error saving programs: ${response.status} - ${response.statusText}`
                    );
                    console.error(`Response body: ${errorBody}`);
                } else {
                    console.log("Programs saved to ACF successfully.");
                }
            } catch (error) {
                console.error("Error sending saved list to backend:", error);
            } finally {
                this.loading = false;
            }
        },
        async fetchSavedPrograms() {
            this.loading = true; // Set loading to true while fetching
            try {
                const response = await fetch(
                    `${this.rest_api}/wp-json/custom/v1/get-saved-programs`,
                    {
                        method: "GET",
                        headers: {
                        "Content-Type": "application/json",
                        "X-WP-Nonce": window.nonce, // Pass the nonce
                        },
                        credentials: "same-origin", // Ensure cookies are sent
                    }
                );

                if (!response.ok) {
                    if (response.status === 401) {
                        console.warn("User is not logged in. Cannot fetch saved programs.");
                        this.savedList = []; // Clear saved list if logged out
                    } else {
                        console.error(`Error fetching saved programs: ${response.status}`);
                    }
                    return; // Exit the function on error
                }

                const savedPrograms = await response.json();
                console.log("Fetched saved programs:", savedPrograms);

                if (Array.isArray(savedPrograms) && savedPrograms.length > 0) {
                    this.savedList = savedPrograms;
                } else {
                    this.savedList = []; // Reset saved list if no saved programs
                }
            } catch (error) {
                console.error("Error fetching saved programs:", error);
            } finally {
                this.loading = false; // Reset loading state
            }
        },
        handleSearchClear(event) {
            if (event.target.value === "") {
                this.searchQuery = "";
                this.applyFilters();
            }
        },
        printString(string) {
            return window.translations[string];
        },
        checkMobile() {
            this.isMobile = window.innerWidth < 768;
            if (!this.isMobile) {
                this.showMobileFilters = false;
            }
        },
        toggleMobileFilters() {
            this.showMobileFilters = !this.showMobileFilters;

            this.$nextTick(() => {
                const sidebarFilters = document.getElementById("sidebar-filters");
                if (sidebarFilters) {
                    if (this.showMobileFilters) {
                        sidebarFilters.focus();
                        this.setFilterElementsTabIndex(0);
                    } else {
                        const otherFiltersButton = document.getElementById("other-filters-button");
                        if (otherFiltersButton) {
                            otherFiltersButton.focus();
                        }
                        this.setFilterElementsTabIndex(-1);
                    }
                }
            });
        },
        setFilterElementsTabIndex(tabIndex) {
            const sidebarFilters = document.getElementById("sidebar-filters");
            if (sidebarFilters) {
                const focusableElements = sidebarFilters.querySelectorAll(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                );
                focusableElements.forEach((el) => {
                    el.setAttribute("tabindex", tabIndex);
                });
            }
        },
        handleEscKey(event) {
            if (event.key === "Escape" && this.showMobileFilters) {
                this.toggleMobileFilters();
            }
        },
        saveFilterState() {
            const filterState = {
                selectedProvinces: this.selectedProvinces,
                selectedAreasOfStudy: this.selectedAreasOfStudy,
                selectedProgramLevels: this.selectedProgramLevels,
                selectedUniversities: this.selectedUniversities,
                selectedLanguage: this.selectedLanguage,
                searchQuery: this.searchQuery,
                coopAvailability: this.coopAvailability,
                remoteLearning: this.remoteLearning,
            };
            sessionStorage.setItem("programFilters", JSON.stringify(filterState));
        },
        loadFilterState() {
            const savedState = sessionStorage.getItem("programFilters");
            console.log("loadFilterState", savedState);
            if (savedState) {
                const filterState = JSON.parse(savedState);
                this.selectedProvinces = filterState.selectedProvinces;
                this.selectedAreasOfStudy = filterState.selectedAreasOfStudy;
                this.selectedProgramLevels = filterState.selectedProgramLevels;
                this.selectedUniversities = filterState.selectedUniversities;
                this.selectedLanguage = filterState.selectedLanguage;
                this.searchQuery = filterState.searchQuery;
                this.coopAvailability = filterState.coopAvailability;
                this.remoteLearning = filterState.remoteLearning;
            }
            return true;
        },
        updateLanguageSwitcherUrl() {
            const languageSwitcher = document.querySelector('.languages');
            if (languageSwitcher) {
                const langLink = languageSwitcher.querySelector(`.languages__item:not(.active)`);
                
                if (langLink) {
                    let baseUrl = window.language_switcher_url;
                    let newPath;

                    if (this.site_lang === 'fr') {
                        // We're on French site, building English URL
                        newPath = `/programs/`;
                        // Remove '/fr' from the end of baseUrl if it exists
                        baseUrl = baseUrl.replace(/\/fr\//, '');
                    } else {
                        // We're on English site, building French URLhttps://rain-digital.ca/
                        newPath = `/programs/`;
                    }
                    
                    const newUrl = `${baseUrl}${newPath}`;
                    langLink.href = newUrl;

                    console.log(`Language switcher URL updated: ${newUrl}`);
                }
            }
        },
        async getCacheKey(requestData) {
            // Create a unique cache key based on the request parameters
            const sortedData = Object.keys(requestData).sort().reduce((obj, key) => {
                obj[key] = requestData[key];
                return obj;
            }, {});
            return `programs-${JSON.stringify(sortedData)}`;
        },
        async getCachedData(cacheKey) {
            try {
                const cache = await caches.open('programs-cache');
                const cachedResponse = await cache.match(cacheKey);
                
                if (cachedResponse) {
                    const cacheData = await cachedResponse.json();
                    const ageInMinutes = (Date.now() - cacheData.timestamp) / (1000 * 60);
                    
                    // Check if cache has expired
                    if (ageInMinutes > cacheData.expirationMinutes) {
                        console.log('Cache expired, removing old data');
                        await cache.delete(cacheKey);
                        return null;
                    }
                    
                    return cacheData.data;
                }
            } catch (error) {
                console.warn('Error reading from cache:', error);
            }
            return null;
        },
        async setCachedData(cacheKey, data, expirationMinutes = 30) {
            try {
                const cache = await caches.open('programs-cache');
                const cacheData = {
                    data: data,
                    timestamp: Date.now(),
                    expirationMinutes: expirationMinutes
                };
                const response = new Response(JSON.stringify(cacheData));
                await cache.put(cacheKey, response);
            } catch (error) {
                console.warn('Error writing to cache:', error);
            }
        },
        async setCacheWithCustomDuration(cacheKey, data) {
            let expirationMinutes;
            
            // Example: Set different durations based on request parameters
            if (this.searchQuery) {
                // Search queries cache for shorter time
                expirationMinutes = 30;
            } else if (this.pageNumber > 1) {
                // Pagination requests cache for medium time
                expirationMinutes = 150;
            } else {
                // Default filters cache for longer
                expirationMinutes = 300;
            }

            await this.setCachedData(cacheKey, data, expirationMinutes);
        },
        selectRandomAd() {
            // Wait for next tick to ensure DOM is updated
            this.$nextTick(() => {
                // First, hide all ad items
                const adItems = document.querySelectorAll('.PartnersAd1 li');
                adItems.forEach(item => item.style.display = 'none');

                // If we have ads, select and show a random one
                if (adItems.length > 0) {
                    const randomIndex = Math.floor(Math.random() * adItems.length);
                    adItems[randomIndex].style.display = 'block';
                    
                    console.log('Ads found:', {
                        totalAds: adItems.length,
                        selectedIndex: randomIndex,
                        selectedAd: adItems[randomIndex]
                    });
                } else {
                    console.log('No ads found in DOM');
                }
            });
        },
        getParamsFromUrl() {
            const params = new URLSearchParams(window.location.search);
            return {
                provinces: params.get('province')?.split(',') || [],
                areasOfStudy: params.getAll('area'),
                programLevels: params.getAll('level'),
                universities: params.get('university')?.split(',') || [],
                language: params.get('language') || '',
                search: params.get('search') || '',
                coop: params.get('coop') === 'true' ? true : params.get('coop') === 'false' ? false : null,
                remote: params.get('remote') === 'true' ? true : params.get('remote') === 'false' ? false : null,
            };
        },
        areFiltersEqual(urlParams) {
            return (
                JSON.stringify(this.selectedProvinces) === JSON.stringify(urlParams.provinces) &&
                JSON.stringify(this.selectedAreasOfStudy) === JSON.stringify(urlParams.areasOfStudy) &&
                JSON.stringify(this.selectedProgramLevels) === JSON.stringify(urlParams.programLevels) &&
                JSON.stringify(this.selectedUniversities) === JSON.stringify(urlParams.universities) &&
                this.selectedLanguage === urlParams.language &&
                this.searchQuery === urlParams.search &&
                this.coopAvailability === urlParams.coop &&
                this.remoteLearning === urlParams.remote
            );
        },
        updateUrlParams() {
            const params = new URLSearchParams();

            // Add parameters only if they have values
            if (this.selectedProvinces.length) {
                console.log("selectedProvinces", this.selectedProvinces);
                params.set('province', this.selectedProvinces);
            }
            if (this.selectedAreasOfStudy.length) {
                this.selectedAreasOfStudy.forEach(area => params.append('area', area));
            }
            if (this.selectedProgramLevels.length) {
                this.selectedProgramLevels.forEach(level => params.append('level', level));
            }
            if (this.selectedUniversities.length) {
                params.set('university', this.selectedUniversities);
            }
            if (this.selectedLanguage) {
                params.set('language', this.selectedLanguage);
            }
            if (this.searchQuery) {
                params.set('search', this.searchQuery);
            }
            if (this.coopAvailability !== null) {
                params.set('coop', this.coopAvailability);
            }
            if (this.remoteLearning !== null) {
                params.set('remote', this.remoteLearning);
            }

            // Update URL without reloading the page
            const newUrl = `${window.location.pathname}${params.toString() ? '?' + params.toString() : ''}`;
            window.history.pushState({}, '', newUrl);
        },
    },
};
</script>
